// actions/serializeDetailActions.js
import {
    FETCH_SERIALIZE_DETAIL_REQUEST,
    FETCH_SERIALIZE_DETAIL_SUCCESS,
    FETCH_SERIALIZE_DETAIL_FAILURE,
  } from './serializeDetailTypes';
  import config from '../../config';
  
  // Action to start fetching
  export const fetchSerializeDetailRequest = () => ({
    type: FETCH_SERIALIZE_DETAIL_REQUEST,
  });
  
  // Action for successful fetch
  export const fetchSerializeDetailSuccess = (students) => ({
    type: FETCH_SERIALIZE_DETAIL_SUCCESS,
    payload: students,
  });
  
  // Action for failed fetch
  export const fetchSerializeDetailFailure = (error) => ({
    type: FETCH_SERIALIZE_DETAIL_FAILURE,
    payload: error,
  });
  
  // Thunk action for fetching serialized details by class_admitted
  export const fetchSerializeDetail = (classAdmitted) => {
    return async (dispatch) => {
      dispatch(fetchSerializeDetailRequest());
      try {
        const response = await fetch(`${config.apiBaseUrl}/students/get/serializeDetail.php?class_admitted=${classAdmitted}`);
        const data = await response.json();
  
        if (response.ok) {
          dispatch(fetchSerializeDetailSuccess(data.data));
        } else {
          dispatch(fetchSerializeDetailFailure('Failed to fetch data'));
        }
      } catch (error) {
        dispatch(fetchSerializeDetailFailure(error.message));
      }
    };
  };
  